export default __webpack_public_path__ + "static/media/list_mobile.08f9848e.svg";